<template>
  <div class="container">
    <div class="title">Hifoto·{{ title }}</div>
    <div class="operation">
      <div class="select">
        <div>
          <el-select
            v-model="value"
            class="m-2 selet"
            placeholder="Select"
            size="large"
            @change="reset"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div @click="displayPpt" class="play-box">
          <span>play</span>
          <img class="play" :src="require('@/assets/播放.png')" alt="播放" />
        </div>
      </div>
      <div class="copy">
        <el-input class="copy_input" style="height: 40px" v-model="url">
          <template #append>
            <span @click="copy(url)">copy</span>
          </template>
        </el-input>
      </div>
    </div>
    <div class="line"></div>
    <div class="infinite-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        :style="{ marginLeft: index % rowSize === 0 ? '0' : '' }"
        class="infinite-list-item"
      >
        <video
          class="children"
          preload="metadata"
          v-if="isVideo(item.attributes.file._url)"
          :data-src="item.attributes.file._url"
          @click="openImage(item.attributes.md5)"
          :ref="(el) => (videoRefs[index] = el)"
        ></video>
        <img
          class="children"
          v-else-if="item.attributes.thumbnail?.url()"
          :data-src="item.attributes.thumbnail.url()"
          alt=""
          @click="openImage(item.attributes.md5)"
          :ref="(el) => (imgRefs[index] = el)"
        />
        <img
          class="children"
          v-else
          :data-src="item.attributes.file._url"
          alt=""
          @click="openImage(item.attributes.md5)"
          :ref="(el) => (imgRefs[index] = el)"
        />
        <div
          class="label"
          v-if="notPicture('MP4,mp4,GIF,gif', item.attributes.file._url)"
        >
          {{ notPicture("MP4,mp4,GIF,gif", item.attributes.file._url) }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-infinite-scroll="nextPage"
    infinite-scroll-distance="50vh"
    ref="bottomDivRef"
    class="bottom_div"
  >
    <div v-if="!finish">not enough┗|｀O′|┛...</div>
    <div v-else>I have boundaries≧ ﹏ ≦</div>
  </div>
  <detail-img v-model:show="show" v-model:url="imgUrl"></detail-img>
  <ppt-display ref="PptDisplayRef"></ppt-display>
</template>
<script setup>
import { ref, onMounted, onUpdated, watch } from "vue";
import { ElSelect, ElOption, ElInput, ElMessage } from "element-plus";
import DetailImg from "./components/detail-img.vue";
import PptDisplay from "./components/ppt-display.vue";
// 请求代码
const queryString = window.location.search;
const listFlag = ref(false);
const urlParams = new URLSearchParams(queryString);
const Parse = require("parse");
onMounted(() => {
  if (urlParams.get("md5")) {
    openImage(urlParams.get("md5"));
  } else {
    listFlag.value = true;
    getList();
  }
  observer = new IntersectionObserver(loadImg, {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  });
  observeImages();
});
onUpdated(() => {
  observeImages();
  const observer = new IntersectionObserver(loadMoreData);
  observer.observe(bottomDivRef.value);
});
Parse.initialize("4b61ad984a1", "ec8fbdb80b9ca");
Parse.serverURL = "https://hifoto.gbtops.com/api";
const SHAREFILE = Parse.Object.extend("SHAREFILE");
let query = new Parse.Query(SHAREFILE);
const size = 12;
const list = ref([]);
const finish = ref(false);
function reset() {
  const videoElements = document.querySelectorAll(".infinite-list-item video");
  videoElements.forEach((videoElement) => {
    videoElement.src = "";
  });
  const imgElements = document.querySelectorAll(".infinite-list-item img");
  imgElements.forEach((imgElement) => {
    imgElement.src = "";
  });
  list.value.length = 0;
  finish.value = false;
  getList();
}
function notPicture(str, target) {
  const arrayList = str.split(",");
  let label = ref("");
  if (
    arrayList.some((item) => {
      label.value = item;
      return target.endsWith(item);
    })
  ) {
    return label.value;
  } else {
    return "";
  }
}
const getList = async () => {
  if (finish.value) return;
  if (!listFlag.value) return;
  finish.value = true;
  try {
    if (value.value !== "") {
      query.equalTo("file_type", value.value);
    } else {
      query = new Parse.Query(SHAREFILE);
      query.equalTo("theme_id", urlParams.get("theme_id"));
      // query.equalTo("theme_id", "b3505168-37a7-4f14-b0ca-be234ed804f5");
    }
    query.descending("createdAt");
    query.skip(list.value.length);
    query.limit(size);
    const results = await query.find();
    if (results.length === 0) {
      finish.value = true;
      return;
    }
    list.value = [...list.value, ...results];
    finish.value = false;
  } catch (error) {
    () => {
      finish.value = false;
    };
  }
};
// 响应式代码
const title = ref("");
watch(
  function () {
    return list.value;
  },
  (newVal) => {
    for (let item of newVal) {
      if (item.attributes.title) {
        title.value = item.attributes.title;
      }
    }
  }
);
const bottomDivRef = ref(null);
const loadMoreData = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      getList();
    }
  });
};
const url = ref(window.location.href.replace(/&?md5=[^&]*/g, ""));
const imgUrl = ref("");
const value = ref("");
const show = ref(false);
let isInitialTrigger = true;

watch(
  () => show.value,
  (newVal) => {
    if (isInitialTrigger) {
      if (!newVal) {
        listFlag.value = true;
        getList();
        isInitialTrigger = false;
      }
    }
  }
);
const options = ref([
  { value: "", label: "All" },
  { value: 1, label: "Photo" },
  { value: 2, label: "Gif" },
  { value: 3, label: "Video" },
  { value: 4, label: "Photo frame" },
  { value: 5, label: "Image set" },
]);
function openImage(url) {
  imgUrl.value = url;
  show.value = true;
}
function copy(url) {
  const input = document.createElement("input");
  input.value = url;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  ElMessage({
    message: "copy success",
    type: "success",
  });
}
function isVideo(link) {
  return /\.(mp4|MP4)$/i.test(link);
}
const rowSize = ref(4);
function handleScreenWidthChange() {
  const screenWidth = window.innerWidth;
  // 在这里执行屏幕宽度变化时的逻辑
  if (screenWidth < 768) {
    rowSize.value = 2;
  } else {
    rowSize.value = 4;
  }
}
handleScreenWidthChange();
window.addEventListener("resize", handleScreenWidthChange);

const imgRefs = ref([]);
const videoRefs = ref([]);
let observer;
const loadImg = (entries) => {
  let timers = {};
  entries.forEach((entry) => {
    let media = entry.target;
    if (entry.isIntersecting && !media?.dataset.loaded) {
      timers[media.dataset.src] = setTimeout(() => {
        console.log("我有来过>>>");
        media.style.opacity = 1;
        media.src = media.dataset.src;
        media.dataset.loaded = true;
        delete timers[media.dataset.src];
      }, 500);
    } else {
      if (timers[media.dataset.src]) {
        clearTimeout(timers[media.dataset.src]);
        delete timers[media.dataset.src];
      }
    }
  });
};
const observeImages = () => {
  imgRefs.value.forEach((img) => {
    if (img) {
      observer.observe(img);
    }
  });
  videoRefs.value.forEach((video) => {
    if (video) {
      observer.observe(video);
    }
  });
};
const PptDisplayRef = ref(null);
const displayPpt = () => {
  PptDisplayRef.value.open();
};
function nextPage() {
  getList();
}
</script>

<style>
.container {
  margin: 0 20px;
  background-color: #f5f5f5;
  padding-top: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  text-align: center;
}
.operation {
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-top: 20px;
}
.operation .select {
  flex: 1;
  display: flex;
  align-items: center;
}
.operation .copy {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
}
.operation .play {
  height: 1rem;
  cursor: pointer;
  margin-left: 5px;
}
.operation .play-box {
  display: flex;
  align-items: center;
  color: #3472c7;
  font-weight: 700;
  border: 1px solid #3472c7;
  padding: 10px 20px;
  border-radius: 40px;
  font-size: 14px;
  margin-left: 20px;
}
.infinite-list {
  min-height: 78vh;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  overflow: auto;
}
.infinite-list .infinite-list-item {
  position: relative;
  display: inline-block;
  width: calc(25% - 6px);
  height: auto;
  color: var(--el-color-primary);
  cursor: pointer;
  margin-left: 8px;
  margin-bottom: 0px;
}
.infinite-list .infinite-list-item .children {
  display: inline-block;
  width: 100%;
  min-height: 236px;
  background: #fff;
  color: var(--el-color-primary);
  object-fit: contain;
  aspect-ratio: 1/1;
  cursor: pointer;
}
.infinite-list .infinite-list-item .label {
  padding: 10px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: white;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10%;
}
.line {
  width: 1px;
  height: 50px;
}
.copy_input {
  width: 60% !important;
}
/* 输入框 */
.el-input-group--append > .el-input__wrapper {
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
}
/* 地址copy 输出框后面部分*/
.el-input > .el-input-group__append {
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  cursor: pointer;
  background-color: #fff;
  color: #3472c7;
  font-weight: 700;
}
/* 选择框 */
.el-select .el-input__wrapper {
  border-radius: 100px;
}
/* 弹框全屏 */
.el-overlay-dialog,
.is-fullscreen {
  overflow: visible !important;
  background-color: #f5f5f5 !important;
}
/* 弹框主体 */
.el-dialog__body {
  height: 100% !important;
  padding: 0 !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .title {
    font-size: 14px;
  }
  .container {
    max-width: 1920px;
    margin: 0;
  }
  .infinite-list .infinite-list-item {
    width: calc(50% - 5px);
  }
  .operation {
    margin-top: 20px;
  }
  .operation .select {       
    justify-content: space-between;   
  }
  /* play样式 */
  .operation .play-box {
    border: 1px solid #3472c7;
    padding: 8px 15px;
    border-radius: 40px;
    font-size: 14px;
    margin-right: 5px;
  }
  .line {
    width: 1px;
    height: 10px;
  }
  .infinite-list .infinite-list-item {
    margin-left: 8px;
    margin-bottom: 4px;
  }
  .el-select--large {
    width: 90px;
  }
  .copy_input {
    width: 100% !important;
    margin-left: 5px;
  }
  .infinite-list .infinite-list-item .label {
    bottom: 10px;
    right: 10px;
  }
  /* 弹框样式 */
  .el-dialog__body {
    height: 100%;
    padding: 0 !important;
  }
  .el-dialog__body .img_box {
    height: calc(100vh - 54px);
    margin-top: 20px;
  }
  .el-dialog {
    height: 100vh !important;
  }
  .el-dialog__header {
    text-align: center;
    padding-bottom: 0 !important;
    margin: 0 !important;
  }
  .el-overlay-dialog {
    overflow: hidden !important;
    overflow: hidden !important;    
  }
}
.bottom_div {
  height: 20vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
}
.bottom_div div {
  margin-top: 10vh;
}
</style>
